module.exports = __webpack_public_path__ + "img/key_features--controls.a6acd19f.png";